import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { SORT_BY } from 'lib/enums/search';
import { Box, Text, Icon } from 'roo-ui/components';
import Sort from 'components/Filters/Search/Sort';
import PillButton from 'components/PillButton';
import { useDataLayer } from 'hooks/useDataLayer';
import Modal, { ModalFooter } from 'components/Modal';
import { useModal } from 'lib/hooks';

const SortBySelector = ({ onChange }) => {
  const { emitInteractionEvent } = useDataLayer();
  const { openModal, closeModal, modalProps } = useModal();

  const onOpenModal = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Mobile Filters Buttons', value: `Sort By Selected` });
  }, [openModal, emitInteractionEvent]);

  const onCloseModal = useCallback(() => {
    closeModal();
    emitInteractionEvent({ type: `Mobile Filters Sort By`, value: 'Close Modal Selected' });
  }, [closeModal, emitInteractionEvent]);

  const onSubmitModal = useCallback(() => {
    closeModal();
    emitInteractionEvent({ type: `Mobile Filters Sort By`, value: 'View Results Selected' });
  }, [closeModal, emitInteractionEvent]);

  const onSortByChanged = useCallback(
    (newQuery) => {
      const queryName = SORT_BY[newQuery.sortBy.toUpperCase()].name;
      onChange(newQuery);
      emitInteractionEvent({ type: 'Mobile Filters Sort By', value: `${queryName} Selected` });
    },
    [emitInteractionEvent, onChange],
  );

  return (
    <Fragment>
      <PillButton onClick={onOpenModal}>
        <Text fontSize="xs">Sort</Text>
        <Icon name="expandMore" size={20} />
      </PillButton>
      {modalProps.isOpen && (
        <Modal
          {...modalProps}
          onRequestClose={onCloseModal}
          title="Sort By"
          padding={0}
          footerComponent={() => <ModalFooter submitModal={onSubmitModal} buttonText="View results" />}
        >
          <Box padding={4} bg="greys.porcelain" height="100%">
            <Sort onChange={onSortByChanged} displayHeading={false} />
          </Box>
        </Modal>
      )}
    </Fragment>
  );
};

SortBySelector.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default SortBySelector;
